import { graphqlRequest } from "../common/apiClient";

const LIST_COPILOT_SESSIONS = `
  query ListCopilotSessions($limit: Int) {
    listCopilotSessions(limit: $limit) {
      items {
        sessionId
        title
        model
        messageCount
        totalTokens
        totalInputTokens
        totalOutputTokens
        totalCostUsd
        updatedAt
      }
    }
  }
`;

const GET_COPILOT_SESSION = `
  query GetCopilotSession($sessionId: String!, $messagesLimit: Int) {
    getCopilotSession(sessionId: $sessionId, messagesLimit: $messagesLimit) {
      sessionId
      title
      model
      messageCount
      totalTokens
      totalInputTokens
      totalOutputTokens
      totalCostUsd
      createdAt
      updatedAt
      messages {
        id
        role
        content
        renderSpec
        tools { name status }
        usage {
          inputTokens
          outputTokens
          costUsd
          model
        }
        createdAt
      }
    }
  }
`;

const GET_COPILOT_USER_USAGE = `
  query GetCopilotUserUsage($periodStart: String, $periodEnd: String) {
    getCopilotUserUsage(periodStart: $periodStart, periodEnd: $periodEnd) {
      inputTokens
      outputTokens
      totalTokens
      costUsd
      turnCount
      periodStart
      periodEnd
    }
  }
`;

export function mapGraphqlMessage(m) {
  if (!m) return null;
  return {
    id: m.id,
    role: m.role,
    content: m.content || "",
    renderSpec: m.renderSpec || undefined,
    tools: (m.tools || []).map((t) => ({ name: t.name, status: t.status })),
    usage: m.usage
      ? {
          input_tokens: m.usage.inputTokens,
          output_tokens: m.usage.outputTokens,
          cost_usd: m.usage.costUsd,
          model: m.usage.model,
        }
      : undefined,
    createdAt: m.createdAt ? Date.parse(m.createdAt) || Date.now() : Date.now(),
  };
}

export function sessionTokensFromSummary(s) {
  if (!s) return { input: 0, output: 0, cost: 0 };
  return {
    input: s.totalInputTokens ?? 0,
    output: s.totalOutputTokens ?? 0,
    cost: +(s.totalCostUsd ?? 0).toFixed(5),
  };
}

export function mapSessionSummary(s) {
  return {
    id: s.sessionId,
    title: s.title || "Conversación",
    model: s.model || "haiku",
    tokens: s.totalTokens ?? 0,
    sessionTokens: sessionTokensFromSummary(s),
    updatedAt: s.updatedAt ? Date.parse(s.updatedAt) || Date.now() : Date.now(),
  };
}

export async function fetchCopilotSessions(limit = 30) {
  const data = await graphqlRequest(LIST_COPILOT_SESSIONS, { limit });
  return (data?.listCopilotSessions?.items || []).map(mapSessionSummary);
}

export async function fetchCopilotSession(sessionId, messagesLimit = 60) {
  const data = await graphqlRequest(GET_COPILOT_SESSION, { sessionId, messagesLimit });
  const session = data?.getCopilotSession;
  if (!session) return null;
  return {
    summary: mapSessionSummary(session),
    messages: (session.messages || []).map(mapGraphqlMessage).filter(Boolean),
    sessionTokens: sessionTokensFromSummary(session),
    model: session.model || "haiku",
  };
}

export async function fetchCopilotUserUsage(periodStart, periodEnd) {
  const data = await graphqlRequest(GET_COPILOT_USER_USAGE, { periodStart, periodEnd });
  return data?.getCopilotUserUsage || null;
}
